<template>
  <v-ons-navigator id="app" swipeable :page-stack="pageStack" @postpush="isSplashScreenHidden = true" @postpop="isSplashScreenHidden = true">
    <component v-for="page in pageStack" :is="page" :page-stack="pageStack" :key="page.key"
               @reload-app="reloadApp" @call-api="callApi"
               @update-if-needed="updateIfNeeded" @change-multi="changeMulti" @set-multi="setMulti" @set-push-ok="setPushOk"></component>
  </v-ons-navigator>
</template>

<script>
import mixinsCommons from './mixins/commons.js';

import { store } from './store.js';
import { Storage } from '@ionic/storage';
import { Drivers } from '@ionic/storage';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';

import AppAccueil from './pages/Accueil.vue';
import AppHome from './pages/Home.vue';
import AppLoginEmail from './pages/LoginEmail.vue';
import AppLoginPassword from './pages/LoginPassword.vue';

import AppReferentiel from './data/referentiel.json';

export default {
  props: ['isResume', 'isDeepLink', 'idPushNotif', 'initPath', 'bgFetch'],
  mixins: [mixinsCommons],
  data() {
    return {
      pageStack: [AppAccueil],
      state: store.state,
      data: store.data,
      isInitApp: false,
      isUserLoaded: false,
      isSplashScreenHidden: false,
      dateCallApi: 0
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    multi() {
      return this.state.multi;
    },
    api() {
      return this.state.api;
    },
    isSync() {
      return this.state.isSync;
    },
    pushOk() {
      return this.state.push_ok;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cours() {
      return this.data.cours;
    },
    negoce() {
      return this.data.negoce;
    },
    live() {
      return this.data.live;
    },
    quiz() {
      return this.data.quiz;
    },
    date() {
      return this.data.date;
    }
  },
  watch: {
    isSplashScreenHidden(val) {
      // debug console.log('watch isSplashScreenHidden ' + this.isSplashScreenHidden);
      val && this.$splashScreen('hide');
    },
    isResume() {
      if(this.isUserLoaded && this.date){
        // debug console.log('update from isResume');
        this.updateIfNeeded();
        this.sendTrackEvent('open');
      } else {
        // debug console.log('isResume bypass user ' + this.isUserLoaded + ' date ' + this.date);
      }
      store.data.now = new Date().getTime();
    },
    isDeepLink() {
      this.handleDeeplink('deeplink');
    },
    idPushNotif(val) {
      this.handleDeeplink('push open ' + val);
    },
    'bgFetch.count'(val) {
      var bgFetch = this.bgFetch;
      if(val && this.isUserLoaded && ! this.isSync){
        store.state.isSync = true;
        this.callApi({
          only_sync: true,
          done: function () {
            store.state.isSync = false;
            bgFetch.done && bgFetch.done();
          }
        });
      } else {
        // from timeout
        store.state.isSync = false;
        bgFetch.done && bgFetch.done();
      }
    }
  },
  methods: {
    async handleDeeplink(trackEvent){
      if(this.isInitApp){
        // debug console.log('handleDeeplink show splashScreen');
        this.initPath && this.$splashScreen('show'); // avoid splashScreen for bg push notif
        this.isSplashScreenHidden = false;
        store.data.date = 0; // force update + block refresh from resume
        await this.ionicStorage.set('date', 0); // if switch recolte ==>> initAppFromStorage
        await this.setInitPath(trackEvent); // ==>> hide splashScreen
      } else {
        // debug console.log('handleDeeplink bypass isInitApp ' + this.isInitApp);
      }
    },
    async setInitPath(trackEvent, isFromInit){
      var path = this.initPath.split('/');
      path.shift(); // root /
      path.shift(); // app/
      if (this.isUserLoaded) {

        var isLoaded = true;
        var idMulti = path.shift(); // possibly "" or even undef
        if (idMulti){
          if (idMulti == 'nd'){
            idMulti = this.user.id.toString();
          } else if(idMulti.length == 2){
            idMulti = Math.floor(parseInt(this.user.id) / 100).toString() + idMulti;
          }
          isLoaded = await this.changeMulti({ // ==>> hide splashScreen
            idMulti: idMulti,
            initPath: idMulti + '/' + path.join('/')
          });
        } else if (isFromInit){
          this.initAppWithPath(); // ==>> hide splashScreen
        } else {
          // debug console.log('setInitPath with user else hide splashScreen');
          this.$splashScreen('hide');
        }

        if (isLoaded){
          // debug console.log('update from setInitPath');
          await this.updateIfNeeded();
        } else {
          // updateIfNeeded ==>> reloadApp
        }
        trackEvent && this.sendTrackEvent(trackEvent + ' ' + this.initPath); // risk multi cookie SESSION

      } else if (path[0] == 'login') {
        this.pageStack.splice(1, this.pageStack.length - 1);
        // debug console.log('setInitPath pageStack push login');
        this.pageStack.push(AppLoginEmail); // ==>> hide splashScreen
      } else {
        // debug console.log('setInitPath else hide splashScreen');
        this.$splashScreen('hide');
      }
    },
    async changeMulti(event) {

      if (event.idMulti == this.user.id) {

        this.initAppWithPath(event); // ==>> hide splashScreen
        return true;

      } else if (this.multi[event.idMulti]) {

        const multi = await this.ionicStorage.get('multi');

        const setStore = [ this.ionicStorage.set('user', multi[event.idMulti]) ];
        delete multi[event.idMulti];

        multi[this.user.id] = this.user;
        setStore.push(this.ionicStorage.set('multi', multi));
        await Promise.all(setStore);

        await this.initAppFromStorage();
        this.initAppWithPath(event); // ==>> hide splashScreen
        return true;

      } else {

        // create campagne via Home
        this.initAppWithPath(event); // ==>> hide splashScreen
        return false;

      }
    },
    async getUserFromStorage() {
      let user = await this.ionicStorage.get('user');
      if(! user){
        user = localStorage.getItem('user');
        if(user){
          // migration from localStorage
          await Promise.all(
            [
              'user',
              'app_token',
              'referentiel',
              'cours',
              'negoce',
              'live',
              'quiz_data',
              'date',
              'onboarding',
              'quiz_state',
              'notif_state',
              'multi',
              'api',
            ].map(
              async (key) => {
                let val = localStorage.getItem(key);
                if(val){
                  if(key != 'app_token'){
                    val = JSON.parse(val);
                  }
                  await this.ionicStorage.set(key, val);
                  localStorage.removeItem(key);
                }
          }));
          user = JSON.parse(user);
        }
      }
      if(! user){
        throw new Error();
      }
      return user;
    },
    async reloadApp(event) {
      await this.initAppFromStorage();
      this.initAppWithPath(event);
      // debug console.log('update from reloadApp');
      await this.updateIfNeeded();
    },
    async initAppFromStorage(isInitNotif) {
      store.state.user = await this.getUserFromStorage();

      const initStore = [
          { dbKey: 'app_token', storeParent: 'state' },
          { dbKey: 'cours', storeParent: 'data' },
          { dbKey: 'negoce', storeParent: 'data' },
          { dbKey: 'histo', storeParent: 'data' },
          { dbKey: 'live', storeParent: 'data' },
          { dbKey: 'quiz_data', storeParent: 'data', storeKey: 'quiz' },
          { dbKey: 'date', storeParent: 'data' },
          { dbKey: 'quiz_state', storeParent: 'state', storeKey: 'quiz' },
        ].map(
          async (item) => {
            const val = await this.ionicStorage.get(item.dbKey);
            if(val){
              store[item.storeParent][item.storeKey ? item.storeKey : item.dbKey] = val;
            }
        });

      const initReferentiel = async () => {
        store.data.referentiel = AppReferentiel;
        const referentiel = await this.ionicStorage.get('referentiel');
        if (referentiel) {
          let appVersion = this.$appVersion.split('.');
          appVersion = parseInt(appVersion[0])*10000 + parseInt(appVersion[1])*100 + parseInt(appVersion[2]);
          if(referentiel.version >= appVersion){
            store.data.referentiel = referentiel;
          }
        }
      };
      initStore.push(initReferentiel());

      const initOnboarding = async () => {
        const onboarding = await this.ionicStorage.get('onboarding');
        if (onboarding && onboarding.version) {
          store.state.onboarding = onboarding;
        } else {
          store.state.onboarding = {
            version: this.$appVersion,
            // migration old onboarding format
            step: onboarding ? Math.min(parseInt(onboarding), 4) : 1,
            nbFeuille: onboarding ? Math.max(0, parseInt(onboarding) - 4) : 0
          };
        }
      };
      initStore.push(initOnboarding());

      const initApi = async () => {
        const api = await this.ionicStorage.get('api');
        if (api) {
          store.state.api = api.length;
        }
      };
      initStore.push(initApi());

      await Promise.all(initStore);

      if(! this.referentiel.date){ // referentiel from app ==>> maj ==>> force update
        store.data.date = 0;
        await this.ionicStorage.set('date', 0); // if switch recolte ==>> initAppFromStorage
      }

      // init store notif
      // user needed
      let notifState = await this.ionicStorage.get('notif_state');
      let isSetNotifState = false;
      if (! notifState) {
        notifState = {};
      }
      if(! notifState[this.user.campagne]){
        notifState[this.user.campagne] = this.getInitNotifState(this.user.ventes);
        isSetNotifState = true;
      }
      if(! notifState.multi){
        notifState.multi = [];
      }
      let idUser = this.user.id.toString();
      idUser = idUser.substring(0, idUser.length - 4);
      if(! notifState.multi.includes(idUser)){
        notifState.multi.push(idUser);
        isSetNotifState = true;
      }
      if(isSetNotifState){
        await this.ionicStorage.set('notif_state', notifState);
      }
      store.state.notif = notifState[this.user.campagne];

      // init store multi
      // notif_state needed
      const multi = await this.ionicStorage.get('multi');
      await this.setMulti(multi, {
        isNoSetStorage: true,
        isInitNotif: isInitNotif
      });
    },
    initAppWithPath(event) {
      this.pageStack.splice(0, this.pageStack.length);
      // debug console.log('initAppWithPath pageStack push home');
      this.pageStack.push({ // ==>> hide splashScreen
        extends: AppHome,
        data() {
          return {
            initPath: event && event.initPath ? event.initPath : ''
          }
        },
        onsNavigatorOptions: {
          animation: 'fade-ios'
        }
      });
    },
    getInitNotifState(listVentes){
      var list = {};
      for (const refCulture in listVentes) {
        for (const refDestination in listVentes[refCulture]) {
          var strategie = listVentes[refCulture][refDestination];
          if (strategie.done) {
            for (let i = 0; i < strategie.done.length; i++) {
              var vente = strategie.done[i];
              if(vente.negoce && vente.etat != 'demande'){
                if(! list[refCulture]){
                  list[refCulture] = {};
                }
                if(! list[refCulture][refDestination]){
                  list[refCulture][refDestination] = [];
                }
                list[refCulture][refDestination].push(vente.id);
              }
            }
          }
        }
      }
      return list;
    },
    async setMulti(multi, opts){
      if(multi[this.user.id]){
        // debug console.error('update multi failed');
        return false; // switch recolte occured
      }
      const notifState = await this.ionicStorage.get('notif_state');
      if(! notifState.multi){
        notifState.multi = [];
      }
      let isSetNotifState = false;
      store.state.multi = {};
      let isNotifNewMulti = true;
      for (const id in multi) {
        const multiUser = multi[id];

        if(! notifState[multiUser.campagne]){
          if(opts && opts.isInitNotif){
            notifState[multiUser.campagne] = this.getInitNotifState(multiUser.ventes);
          } else {
            notifState[multiUser.campagne] = {};
          }
          isSetNotifState = true;
        }
        let idUser = id.toString();
        idUser = idUser.substring(0, idUser.length - 4);
        
        store.state.multi[id] = {
          date: multiUser.date,
          campagne: parseInt(multiUser.campagne),
          label: this.getFermeLabel(multiUser),
          nbCult: multiUser.cultures.length,
          nbNotif: this.getCampagneNotifCount(multiUser.ventes, this.getNegoceAcces(this.negoce.list, null, id), notifState[multiUser.campagne])
            + (! notifState.multi.includes(idUser) && isNotifNewMulti ? 1 : 0)
        };
        if(! notifState.multi.includes(idUser)){
          isNotifNewMulti = false;
        }
      }
      if(isSetNotifState){
        await this.ionicStorage.set('notif_state', notifState);
      }
      if(!(opts && opts.isNoSetStorage)){
        await this.ionicStorage.set('multi', multi);
      }
      return true;
    },
    async updateIfNeeded() {
      var dateNow = new Date().getTime();
      const isNotOnCall = (dateNow - this.dateCallApi > 5 * 60 * 1000); // 5 min after last call (!dateCallApi || error)
      const isRefreshExpired = (dateNow - this.date > this.$refreshInterval * 1000); // refreshInterval from config
      if (isNotOnCall && isRefreshExpired) {
        store.state.isSync = true;
        await this.callApi({ is_silent: true });
        store.state.isSync = false
        if(! this.date){
          store.data.date = 1; // release refresh from resume
        }
      } else {
        // debug console.log('update bypass notOnCall ' + isNotOnCall + ' expired ' + isRefreshExpired);
      }
    },
    async getApi() {
      let api = await this.ionicStorage.get('api');
      if (! api) {
        api = [];
      }
      return api;
    },
    async callApi(event) {
      let api = await this.getApi();

      if (event && event.call) {
        api.push(event.call);
        await this.ionicStorage.set('api', api);
        if(this.dateCallApi){
          event && event.done && event.done();
          return;
        }
      }

      this.dateCallApi = new Date().getTime();

      if (api.length) {
        // debug console.log('call api with event ' + event && event.call);
        var call = api[0];

        if(event && event.only_sync && !call.isBgFetch) {
          this.dateCallApi = 0;
          event && event.done && event.done();
          return;
        }

        const fetchInit = this.$getFetchInit(call.method);
        fetchInit.body = JSON.stringify(call.data);
        let callPath = this.$apiDomain + call.path;
        if(event && event.only_sync) {
          callPath += '&bgfetch=1';
        }
        try {
          const response = await this.handleRequest(callPath, fetchInit);
          if(response.user){ // /negoce/otp
            await this.updateUserFromResponse(response.user);
          }

          api = await this.getApi();
          api.splice(0, 1);
          await this.ionicStorage.set('api', api);
          if (api.length) {
            await this.callApi({ only_sync: event && event.only_sync }); // event object can contain call
          } else {
            store.state.api = 0;
            if (!(event && event.call)) {
              // if here => from retry
              this.$showToast();
              // refresh
              await this.callApi({ is_silent: true });
            }
          }

        } catch(error) {
          store.state.api = api.length;
          if (error.status == 410 || error.status == 401) {
            await this.ionicStorage.remove('api');
            store.state.api = 0;
            this.handleError(error);
          } else if (error.is_custom) {
            this.handleError(error, '', true);
          } else {
            this.$showToast('Synchronisation impossible');
          }
        }

      } else if(!(event && event.only_sync)) {
        // debug console.log('updating data ...');
        var urlParams = {
          'user_date': this.user.date,
          'referentiel_date': this.referentiel.date,
          'cours_date': this.cours.date,
          'negoce_date': this.negoce.date,
          'histo_date': this.data.histo.date,
          'live_date': this.live.date,
          'quiz_date': this.quiz.date
        };

        var pushToken = localStorage.getItem('push_token');
        if(pushToken){
          urlParams.push_token = pushToken;
        }
        if(this.pushOk !== null){
          urlParams.push_ok = this.pushOk ? 1 : 0;
        }

        urlParams.multi_date = Object.values(this.multi).reduce((result, val) => { return val.date > result ? val.date : result; }, '');

        const fetchInit = this.$getFetchInit('GET');
        const callPath = this.$apiDomain + this.getPath('/json', urlParams);
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          const majStoreUser = [];
          if (response.user) {
            majStoreUser.push(this.updateUserFromResponse(response.user));
          }
          if(response.multi && Object.keys(response.multi).length){
            majStoreUser.push(this.setMulti(response.multi));
          }

          const majStoreList = [Promise.all(majStoreUser)];

          if (response.app_token) {
            const majStoreItem = async () => {
              store.state.app_token = response.app_token;
              await this.ionicStorage.set('app_token', response.app_token);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.referentiel) {
            const majStoreItem = async () => {
              store.data.referentiel = response.referentiel;
              await this.ionicStorage.set('referentiel', response.referentiel);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.cours) {
            const majStoreItem = async () => {
              store.data.cours = response.cours;
              await this.ionicStorage.set('cours', response.cours);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.negoce) {
            if(! response.negoce.request){
              response.negoce.request = store.data.negoce.request;
            }
            if(! response.negoce.suggest){
              response.negoce.suggest = store.data.negoce.suggest;
            }
            if(! response.negoce.clients){
              response.negoce.clients = store.data.negoce.clients;
            }
            const majStoreItem = async () => {
              store.data.negoce = response.negoce;
              await this.ionicStorage.set('negoce', response.negoce);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.histo) {
            const majStoreItem = async () => {
              store.data.histo = response.histo;
              await this.ionicStorage.set('histo', response.histo);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.live) {
            const majStoreItem = async () => {
              store.data.live = response.live;
              await this.ionicStorage.set('live', response.live);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.quiz) {
            const majStoreItem = async () => {
              store.data.quiz = response.quiz;
              await this.ionicStorage.set('quiz_data', response.quiz);
            };
            majStoreList.push(majStoreItem());
          }
          if (response.popup) {
            store.state.badge.content = response.popup;
            store.state.badge.type = 'custom';
          }

          if (majStoreUser.length || majStoreList.length > 1) {
            this.$showToast('Données mises à jour');
          } else if (!(event && event.is_silent)) {
            this.$showToast('Aucune mise à jour');
          }

          const majStoreResult = await Promise.all(majStoreList);

          if (majStoreResult[0].reduce((result, val) => { return result && val; }, true)){ // maj date unless user / multi update fail
            var dateNow = new Date().getTime();
            store.data.now = dateNow;
            store.data.date = dateNow;
            await this.ionicStorage.set('date', dateNow);
          }

          event && event.success && event.success();
          
        } catch(error) {
          if (error.status == 410 || error.status == 401) {
            this.handleError(error);
          } else if (!(event && event.is_silent)) {
            if (error.is_custom) {
              this.handleError(error, '', true);
            } else {
              this.$showToast('Échec de la mise à jour');
            }
          }
          event && event.error && event.error(error);
        }
      }

      this.dateCallApi = 0;
      event && event.done && event.done();
    },
    setPushOk() {
      if (window.FirebasePlugin) {
        window.FirebasePlugin.hasPermission(function(hasPermission){
          if(! hasPermission){
            window.FirebasePlugin.grantPermission(function (hasPermission) {
              if(hasPermission){
                store.state.push_ok = true;
              }
            });
          }
        });
      }
    },
    async initAppAsync() {
      store.storage.ionic = new Storage({
        driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage]
      });
      await this.ionicStorage.defineDriver(CordovaSQLiteDriver);
      await this.ionicStorage.create();
      // debug console.log('ionicStorage ready using driver ' + this.ionicStorage.driver + ' from ' + this.ionicStorage._config.driverOrder);
      try {
        await this.initAppFromStorage(true); // from storage ==>> notif already set or from login ==>> initNotif
        this.isUserLoaded = true;
      } catch(error) {
        this.pageStack.splice(0, this.pageStack.length);
        // debug console.log('initAppAsync pageStack push accueil');
        var initPath = '';
        var hideLogin = false;
        if(this.initPath == '/app/login'){
          initPath = 'login'; // console error via setInitPath
        } else if(this.initPath == '/app/new'){
          initPath = 'inscription'; // console error via setInitPath
        }
        this.pageStack.push({ // ==>> hide splashScreen
          extends: AppAccueil,
          data() {
            return {
              hideLogin: hideLogin,
              initPath: initPath,
            }
          },
          onsNavigatorOptions: {
            animation: 'fade-ios'
          }
        });
        if(this.initPath == '/app/password'){
          this.pageStack.push({ // console error "Cannot read properties of undefined (reading '$el')"
            extends: AppLoginPassword,
            data() {
              return {
                showPassword: true
              }
            }
          });
        }
      }
      if(this.isUserLoaded) { // ==>> else hide splashScreen by catch error
        if(this.initPath){
          let trackEvent = '';
          if(this.isDeepLink){
            trackEvent = 'deeplink';
          } else if(this.idPushNotif){
            trackEvent = 'push open ' + this.idPushNotif;
          }
          store.data.date = 0; // force update
          await this.ionicStorage.set('date', 0); // if switch recolte ==>> initAppFromStorage
          await this.setInitPath(trackEvent, true); // ==>> hide splashScreen
        } else {
          this.initAppWithPath(); // ==>> hide splashScreen
          // refresh data on load
          // debug console.log('update from initAppAsync');
          await this.updateIfNeeded();
        }
      }
      this.isInitApp = true; // wait for refresh before handleDeeplink
      this.isUserLoaded && this.sendTrackEvent('init');
    }
  },
  created() {
    store.data.now = new Date().getTime();
    setInterval(function () {
      store.data.now = new Date().getTime();
    }, 1000 * 60);
    this.initAppAsync();
  }
};
</script>
